import "core-js/modules/es.array.push.js";
import { defineComponent, getCurrentInstance, toRefs, reactive, nextTick } from 'vue';
import { onBeforeRouteLeave, userRoute } from 'vue-router';
import { useStore } from '@/store/index';
import Keys from '@/constant/key';
import { beforeUpload, upload } from '@/utils/upload';
import { joinParams } from '@/utils';
import { DelayTypes, AppealStatus, TypeStatus } from '@/enums/order';
import { UserType } from '@/enums/user';
import { getLastMonthToday, getCurrentDate } from '@/utils/index';
import Pagination from '@/components/Pagination';
import { Plus, Delete } from '@element-plus/icons-vue';
export default defineComponent({
  name: 'MerchantList',
  components: {
    Pagination,
    Plus,
    Delete
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const store = useStore();
    const route = useRoute();
    const hasShop = store.state.user.userInfo.hasShop;
    const today = new Date();
    const permission = ["caiwu", "admin"];
    const state = reactive({
      filters: {
        order_type: '3',
        search_value: '',
        time_type: '3',
        appeal_status: route.query.AppealStatus == 0 ? '' : Number(route.query.AppealStatus) || 3,
        start_date: route.query.start_date || getLastMonthToday(),
        end_date: route.query.end_date || getCurrentDate(),
        item_name: '',
        brand_id: null,
        shop_user_id: null,
        limit: 10,
        page: 1
      },
      totalAmount: {
        fk_amount: 0,
        zz_jm_amount: 0,
        jm_amount: 0
      },
      brandList: [],
      // 当前用户关联品牌（非商户类获取全部）
      brandProps: {
        value: 'id',
        label: 'name'
      },
      tableData: [],
      tableDialogData: [],
      //罚款申诉详情弹窗
      tableHeight: 0,
      // table 动态高度
      shopUserList: [],
      shopProps: {
        value: 'id',
        label: 'shop_description'
      },
      count: 0,
      currRow: {},
      // 当前操作数据行

      dialogVisible: false,
      // 申诉弹框
      dialogVisible2: false,
      //详情弹框
      dialogVisible1: false,
      // 上传弹框
      appeal_reason: '',
      // 申诉原因
      type: '',
      //申诉类型
      appeal_file: [],
      // 申诉证明
      reject_reason: '',
      // 驳回原因
      currOrderItemId: '',
      // 当前操作订单ID
      currAppeal: '',
      // 当前操作申诉类型：1-可进行申诉；2-已申诉，可获取申诉信息
      onSizeChange(val) {
        state.filters.limit = val;
        state.getList();
      },
      onPageChange(val) {
        state.filters.page = val;
        state.getList();
      },
      getList() {
        proxy.$http.get(`/admin/fine_order/getFineOrderList?${joinParams({
          ...state.filters
        })}`).then(res => {
          if (res.code == 0) {
            state.tableData = res.data;
            state.count = res.count;
          } else {
            state.tableData = [];
          }
        });
        //调取金额接口
        proxy.$http.get(`/admin/Merchant/get_order_fineinfo?${joinParams({
          ...state.filters
        })}`).then(res => {
          const {
            data,
            code,
            msg
          } = res;
          if (code == 200) {
            state.totalAmount = data;
          } else {
            proxy.$message({
              type: 'error',
              message: msg
            });
          }
        });
      },
      //罚款申诉详情
      toDetail(id, type) {
        proxy.$http.post('/admin/fine_order/getFineRecordList', {
          order_item_id: id,
          type
        }).then(res => {
          if (res.code == 200) {
            state.tableDialogData = res.data;
          } else {
            state.tableDialogData = [];
          }
        });
      },
      // 获取当前用户关联品牌列表
      getBrandList: () => {
        proxy.$http.post('/admin/shop_product/getBrandList?id_show=1').then(res => {
          state.brandList = res.data;
        });
      },
      getShopList: () => {
        proxy.$http.get('/admin/shop_product/getShopList').then(res => {
          if (res.code == 200) {
            state.shopUserList = res.data;
          } else {
            state.shopUserList = [];
          }
        });
      },
      search() {
        state.filters.page = 1;
        state.getList();
      },
      output() {
        window.open(`${Keys.baseUrl}/admin/fine_order/exportFineOrderData?${joinParams({
          ...state.filters,
          user_id: store.state.user.userInfo.id
        })}`);
      },
      // 批量上传成功
      onUploadSuccess: async res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        state.dialogBeforeClose1();
      },
      // 关闭弹框前清空已上传文件列表
      dialogBeforeClose1: () => {
        proxy.$refs.upload.clearFiles();
        state.dialogVisible1 = false;
        state.getList();
      },
      // 关闭罚款弹框
      dialogBeforeClose2: () => {
        state.dialogVisible2 = false;
      },
      //确定上传
      dialogSubmit: () => {
        proxy.$refs.upload.submit();
      }
    });
    // 打开申诉弹框
    const openDialog = row => {
      const {
        id,
        is_appeal
      } = row;
      state.currRow = row;
      if (is_appeal == 1) {
        state.currOrderItemId = id;
      } else {
        getAppealInfo(id);
      }
      state.currAppeal = is_appeal;
      state.dialogVisible = true;
    };
    // 商品详情图上传前校验
    const onBeforeUpload = file => {
      return beforeUpload(file, {
        size: 500
      });
    };
    // 商品图片上传事件
    const onImgUpload = param => {
      uploadRequest(param);
    };
    // 自定义图片上传方法
    const uploadRequest = async param => {
      const res = await upload(param.file, {
        folderName: 'others'
      });
      const {
        code,
        data,
        msg
      } = res;
      if (code != 200) {
        return proxy.$message({
          type: 'error',
          message: msg
        });
      }
      const {
        o_path
      } = data.img_info;
      state.appeal_file.push(o_path);
    };
    // 图片删除
    const onRemove = index => {
      state.appeal_file.splice(index, 1);
    };
    // 申诉
    const onApply = () => {
      const {
        appeal_reason,
        appeal_file,
        currOrderItemId,
        type
      } = state;
      if (!appeal_reason) {
        return proxy.$message({
          type: 'error',
          message: '请输入申诉原因'
        });
      }
      if (type === '') {
        return proxy.$message({
          type: 'error',
          message: '请输入申诉类型'
        });
      }
      proxy.$confirm('每笔订单只有一次申诉机会，确定要提交进入审批流程吗?', '提示', {
        type: 'warning'
      }).then(() => {
        proxy.$http.post('/admin/fine_order/sendFineAppeal', {
          type,
          order_item_id: currOrderItemId,
          appeal_reason,
          appeal_file: appeal_file.join(',')
        }).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          proxy.$message({
            type: 'success',
            message: '保存成功'
          });
          dialogBeforeClose();
          state.getList();
        });
      }).catch(() => {
        console.log('取消申诉');
      });
    };
    // 获取申诉信息
    const getAppealInfo = id => {
      proxy.$http.get(`/admin/fine_order/getFineAppealInfo?order_item_id=${id}`).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        const {
          appeal_reason,
          appeal_file,
          reject_reason,
          type
        } = data;
        state.type = type;
        state.appeal_reason = appeal_reason;
        state.appeal_file = appeal_file && appeal_file.split(',') || [];
        state.reject_reason = reject_reason;
      });
    };
    // 申诉弹框关闭前清空数据
    const dialogBeforeClose = () => {
      state.dialogVisible = false;
      state.type = '';
      state.appeal_reason = '';
      state.appeal_file = [];
      state.reject_reason = '';
    };
    // 设置 table 高度
    const setTableHeight = () => {
      nextTick(() => {
        let headerHeight = 50,
          // 头部高度
          filterHeight = proxy.$refs.filterContainer.offsetHeight + 30,
          // 搜索条件框高度 + 间距
          paginationHeight = 62; // 分页栏高度 + 与 table 之间的间距
        state.tableHeight = window.innerHeight - headerHeight - filterHeight - paginationHeight;
      });
    };
    // 设置 table 高度
    setTableHeight();
    // 监听窗口变化，重置 table 高度
    window.onresize = setTableHeight;
    // 注销 onresize 监听
    onBeforeRouteLeave(() => {
      window.onresize = null;
    });
    state.getList();
    hasShop && state.getShopList();
    state.getBrandList();
    return {
      ...toRefs(state),
      Keys,
      store,
      hasShop,
      permission,
      onApply,
      dialogBeforeClose,
      onBeforeUpload,
      onImgUpload,
      openDialog,
      onRemove,
      DelayTypes,
      AppealStatus,
      TypeStatus,
      UserType
    };
  }
});